<template>
    <div class="flex flex-col pb-16 md:pb-32">
        <Component
            :is="component.component"
            v-for="(component,index) in components"
            :key="index"
            :content="component.data"
            :slug="slug"
            :type="component.typeHandle" />
    </div>
</template>

<script setup>

const props = defineProps({
    slug: {
        type: String,
        default: ""
    },
    structure: {
        type: Object,
        default: {}
    },
})

let components = []

// import components
components = props.structure?.entries[0]?.blocks.map((entity)=> {
    const {typeHandle, ...data} = entity

    if (typeHandle === undefined) {
        console.error('No typeHandle found in entity')
        return data
    }

    // split the data and the component instance so you can v-bind the data easier in the template
    return {
        data: data,
        typeHandle: typeHandle,
        // A note is that if you use path aliases for dynamic imports like @ or ~ you might experience issues.
        component: defineAsyncComponent(() => import(`@/components/pages/cms/blocks/${typeHandle}.vue`))
    }
})



</script>
